import React from 'react'
import ImageScale from '../../components/scale/image_scale'
import { Grid, GridItem } from '../../components/grid'
import css from './style.css'

const CutSection = props => {
  const poorImg = require('./images/cutScale/poor.png')
  const fairImg = require('./images/cutScale/fair.png')
  const goodImg = require('./images/cutScale/good.png')
  const veryGoodImg = require('./images/cutScale/very-good.png')
  const excellentImg = require('./images/cutScale/excellent.png')

  const cutScale = [
    {
      elements: [
        { img: excellentImg, name: 'EXCELLENT' },
        { img: veryGoodImg, name: 'VERY GOOD' },
        { img: goodImg, name: 'GOOD' },
        { img: fairImg, name: 'FAIR' },
        { img: poorImg, name: 'POOR' }
      ]
    }
  ]

  return (
    <div>
      <Grid>
        <div className={css.backgroundCut} />
        <GridItem col='3/10' customStyle={css.gridItem}>
          <div className={css.title}>
            Cut
          </div>
          <p className={css.text}>
            Cut is a measure of the overall proportions and symmetry of a polished diamond. The goal is to minimize light loss and maximize the amount of light that enters the diamond and bounces back toward the eyes. This is where the brilliance or “sparkle” of the diamond comes from. The cut of the diamond is graded as one of: Ideal / Excellent, Very Good, Good, Fair and Poor. We look for quality first, and select our diamonds for maximum fire and brilliance. To accomplish this, we only sell diamonds graded “Ideal”, “Excellent” or “Very Good” in cut. Anything below this does not meet our standards.
          </p>
        </GridItem>
        <GridItem col='7/10' customStyle={css.gridItem}>
          <img className={css.imageCut}
            src={require('./images/cut_graphic.png')}
            srcSet={[
              require('./images/cut_graphic.png') + ' 1x',
              require('./images/cut_graphic@2x.png') + ' 2x'
            ].join(', ')}
          />
        </GridItem>
      </Grid>
      <Grid>
        <GridItem col='1/1' customStyle={css.gridItem}>
          <ImageScale elements={cutScale} imgHeight={80} />
        </GridItem>
      </Grid>
    </div>
  )
}

export default CutSection



// WEBPACK FOOTER //
// ./src/containers/diamond/cut_section.js